/**
 * Normalize API pagination shapes into a consistent client model.
 * Supports paginate() ({ currentPage, totalItems, totalPages, itemsPerPage })
 * and flat shapes ({ page, total, totalPages, limit }).
 */
export function normalizePagination(raw = {}, fallback = {}) {
  if (!raw || typeof raw !== 'object') {
    return {
      page: fallback.page ?? 1,
      limit: fallback.limit ?? 10,
      total: fallback.total ?? 0,
      totalPages: fallback.totalPages ?? 0,
      currentPage: fallback.page ?? 1,
      itemsPerPage: fallback.limit ?? 10,
      totalItems: fallback.total ?? 0,
      pages: fallback.totalPages ?? 0,
    };
  }

  const page = Number(raw.page ?? raw.currentPage ?? fallback.page ?? 1) || 1;
  const limit = Number(raw.limit ?? raw.itemsPerPage ?? fallback.limit ?? 10) || 10;
  const total = Number(raw.total ?? raw.totalItems ?? fallback.total ?? 0) || 0;
  let totalPages = Number(raw.totalPages ?? raw.pages ?? fallback.totalPages ?? 0) || 0;

  if (totalPages <= 0 && total > 0 && limit > 0) {
    totalPages = Math.ceil(total / limit);
  }

  return {
    page,
    limit,
    total,
    totalPages,
    currentPage: page,
    itemsPerPage: limit,
    totalItems: total,
    pages: totalPages,
    hasNextPage: raw.hasNextPage,
    hasPrevPage: raw.hasPrevPage,
    nextPage: raw.nextPage,
    prevPage: raw.prevPage,
  };
}

export function extractPaginatedList(payload) {
  if (Array.isArray(payload)) {
    return { data: payload, pagination: null };
  }
  if (Array.isArray(payload?.data)) {
    return {
      data: payload.data,
      pagination: payload.pagination ?? null,
    };
  }
  if (Array.isArray(payload?.data?.data)) {
    return {
      data: payload.data.data,
      pagination: payload.data.pagination ?? payload.pagination ?? null,
    };
  }
  return { data: [], pagination: payload?.pagination ?? null };
}

export function getPaginationView(stored, listPage = 1, pageSize = 10) {
  const p = normalizePagination(stored, { page: listPage, limit: pageSize });
  return {
    currentPage: p.page,
    totalPages: Math.max(1, p.totalPages || 1),
    totalItems: p.total,
    pageSize: p.limit,
  };
}
